import Reveal from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, description, image, testid }) {
  return (
    <section className="relative overflow-hidden" data-testid={testid}>
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/75" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 sm:pt-24 pb-8 sm:pb-12">
        <Reveal>
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#FEE123]" data-testid={testid ? `${testid}-eyebrow` : undefined}>
            {eyebrow}
          </p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl uppercase leading-none mt-4 text-white max-w-4xl" data-testid={testid ? `${testid}-title` : undefined}>
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-base sm:text-lg text-gray-300 leading-relaxed max-w-2xl" data-testid={testid ? `${testid}-description` : undefined}>
              {description}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
